module.exports = __webpack_public_path__ + "static/media/logo_org_sm.e4b9e4ee.svg";